export const enum NamespacesModules {
    SP = "serviceProviders",
    CP = "contentProviders",
    UserProfile = "userProfile",
    ProvidersUsers = "providersUsers",
    SA = "serviceAccounts",
    ANumbers = "aNumbers",
    Assets = "assets",
    ProgramContents = "programContents",
}

export const enum RootActionsNames {
    ResetState = "resetRootState",
}
